// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".anonymize-students--anonymizeStudents--3JOwqK5o {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  height: 30px;\n  margin: 0 0 3px 15px;\n}\n.anonymize-students--anonymizeStudents--3JOwqK5o .anonymize-students--label--3eyioyhG {\n  font-size: 16px;\n  margin: 0 5px 0 5px;\n  height: 20px;\n}\n", ""]);
// Exports
exports.locals = {
	"anonymizeStudents": "anonymize-students--anonymizeStudents--3JOwqK5o",
	"label": "anonymize-students--label--3eyioyhG"
};
module.exports = exports;
